var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContactDetailsForm',{attrs:{"customer":_vm.customer,"basic-details-card-title":_vm.$t("sidebar.owner") + ' Details',"show-contact-phones":_vm.showContactPhones,"show-contact-emails":_vm.showContactEmails,"show-contact-addresses":_vm.showContactAddresses},on:{"customer-updated":_vm.updateCustomer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f8c2954","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactDetails/ContactDetailsPageBody.vue
// module id = null
// module chunks = 